<template>
  <div class="wrapper" v-loading="ifLoading">
    <div class="contentContainer">
      <!-- <el-form
        :model="searchCondition"
        inline
        ref="searchForm"
        label-width="120px"
      >
        <el-form-item label="关键字" prop="username"> -->
      关键字 &ensp;
      <el-input
        v-model="searchCondition.username"
        placeholder="请输入关键字"
        size="small"
        style="width: 200px"
      ></el-input>
      <!-- </el-form-item>
        <el-form-item> -->
      &emsp;
      <el-button type="primary" size="small" @click="getData">查询</el-button>
      <!-- </el-form-item>
      </el-form> -->
    </div>
    <div class="contentContainer">
      <el-tabs
        v-model="activeName"
        type="card"
        @tab-click="
          () => {
            Object.assign(searchCondition, $options.data().searchCondition);
            getData();
          }
        "
      >
        <el-tab-pane label="登录日志" name="loginLog">
          <el-table :data="loginLog" border style="width: 100%">
            <el-table-column
              prop="createTime"
              label="登录时间"
              min-width="200"
            ></el-table-column
            ><el-table-column
              prop="userName"
              label="登录人员"
              min-width="100"
            ></el-table-column
            ><el-table-column
              prop="terminalType"
              label="终端类型"
              min-width="100"
            ></el-table-column
            ><el-table-column
              prop="browserVersion"
              label="浏览器/终端版本"
              min-width="100"
            ></el-table-column
            ><el-table-column
              prop="operateSystem"
              label="操作系统"
              min-width="100"
            ></el-table-column
            ><el-table-column
              prop="equipmentName"
              label="设备名称"
              min-width="100"
            ></el-table-column
            ><el-table-column
              prop="ip"
              label="登录IP"
              min-width="100"
            ></el-table-column
            ><el-table-column
              prop="address"
              label="地址"
              min-width="100"
            ></el-table-column
          ></el-table>
          <el-pagination
            @size-change="getData"
            @current-change="getData"
            :current-page.sync="searchCondition.pageNumber"
            :page-sizes="[10, 20, 50, 100]"
            :page-size.sync="searchCondition.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="searchCondition.total"
          >
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="操作记录" name="actLog">
          <el-table :data="actLog" border style="width: 100%">
            <el-table-column
              prop="operateNo"
              label="操作编号"
              min-width="100"
            ></el-table-column
            ><el-table-column
              prop="operateTime"
              label="操作时间"
              min-width="100"
            ></el-table-column
            ><el-table-column
              prop="userName"
              label="操作人员"
              min-width="100"
            ></el-table-column
            ><el-table-column
              prop="module"
              label="所属模块"
              min-width="100"
            ></el-table-column
            ><el-table-column
              prop="operateObject"
              label="操作对象"
              min-width="100"
            ></el-table-column
            ><el-table-column
              prop="type"
              label="操作类型"
              min-width="100"
            ></el-table-column
            ><el-table-column
              prop="fieldName"
              label="字段名"
              min-width="100"
            ></el-table-column
            ><el-table-column
              prop="oldOperateObject"
              label="旧字段值"
              min-width="100"
            ></el-table-column
          ></el-table>
          <el-pagination
            @current-change="getData"
            :current-page.sync="searchCondition.pageNumber"
            :page-sizes="[10, 20, 50, 100]"
            :page-size.sync="searchCondition.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="searchCondition.total"
          >
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { singleLoginLog, singleActLog } from "@/api/index";
export default {
  data() {
    return {
      activeName: "loginLog",
      powerTree: [],
      roleData: {},
      loginLog: [],
      searchCondition: {
        username: "",
        pageNumber: 1,
        pageSize: 10,
        total: 0,
      },
      actLog: [],
      ifLoading: false,
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {},
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.ifLoading = true;
      switch (this.activeName) {
        case "loginLog":
          singleLoginLog(this.searchCondition).then((data) => {
            this.loginLog = data.data.rows;
            this.searchCondition.total = data.data.total;
            this.ifLoading = false;
          });
          break;
        case "actLog":
          singleActLog(this.searchCondition).then((data) => {
            this.actLog = data.data.rows;
            this.searchCondition.total = data.data.total;
            this.ifLoading = false;
          });
          break;
        default:
          break;
      }
    },
  },
};

function calcCheckNodes(total, current, idx, arr) {
  if (current.checked) {
    total.push(current.id);
  }
  if (current.children && current.children.length > 0) {
    current.children.reduce(calcCheckNodes, total);
  }
  return total;
}
</script>

<style scoped lang="less">
.wrapper {
  background: #fff;
  padding: 30px 0;
  min-height: 800px;
  .contentContainer {
    border: 1px solid #ccc;
    width: 70%;
    margin: 30px auto;
    padding: 20px;
    .treeContainer {
      padding: 20px 15%;
    }
    .totalDescribe {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .describe {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .el-icon-user-solid {
          font-size: 36px;
          color: #fff;
          padding: 10px;
          background: orange;
          border-radius: 50%;
          margin-right: 20px;
        }
        .name {
          font-size: 14px;
          strong {
            font-size: 18px;
          }
        }
      }
      .actSide {
      }
    }
  }
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
